export default __webpack_public_path__ + "static/media/duster-large.36d5ae5c.jpg";